import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import UserFavoriteComponents from "@/pages/user/UserFavoriteComponents/UserFavoriteComponents";
import { api__listFavourite } from "@/apis/customer/list-favourite";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import BlueSnackBar from "@/_MiniApps/CarCompare/Components/BlueSnackBar";
import StartCompareBar from "@/_MiniApps/CarCompare/Components/StartCompareBar";
var UserFavorite = function UserFavorite() {
  var _useApi = useApi([], api__listFavourite),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    _ = _useApi2[1],
    posts = _useApi2[2];
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    hideHeaderOnmobile: true,
    hideFooter: true,
    disableLoader: true,
    hideAppBanner: true,
    hasNavBar: true,
    pageName: "favorite"
  }, /*#__PURE__*/React.createElement(UserFavoriteComponents, {
    posts: posts
  }), /*#__PURE__*/React.createElement(BlueSnackBar, {
    containerClassName: "md:ar:right-[calc(50%-250px)] en:left-[calc(50%-250px)",
    postsLength: posts.length
  }), /*#__PURE__*/React.createElement(StartCompareBar, {
    containerClassName: "md:ar:right-[calc(50%-250px)] en:left-[calc(50%-250px)"
  }));
};
export default UserFavorite;